import { z } from 'zod';

import { documentDataSchema } from '@/features/ui/DocumentsData/model/schemas';

import { zodPlaceholder } from '@/shared/lib/validations';

export const healthDataBaseSchema = z.object({
  healthDataDocument: zodPlaceholder,
});

export const healthDataSchema = healthDataBaseSchema.superRefine((data, ctx) => {
  const healthDataResult = documentDataSchema.safeParse(data.healthDataDocument);

  if (!healthDataResult.success) {
    healthDataResult.error.issues.forEach((issue) => {
      ctx.addIssue({
        ...issue,
        path: ['healthDataDocument', ...issue.path],
      });
    });
  }
});
